<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";

export default {
    name: "CatalogFilterBlock",
    components: {IconChevronDown},
    props: {
        title: {
            type: String,
            required: true,
        },
        default_open: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            is_open: this.default_open
        }
    },
    methods: {
        toggleOpen() {
            this.is_open = !this.is_open;
        }
    }
}
</script>

<template>
    <div class="w-full border-b border-gray-200 pt-5 transition"
         :class="{'pb-0': !is_open, 'pb-5': is_open}">
        <div class="flex items-center justify-between font-medium cursor-pointer mb-5"
             @click.prevent="toggleOpen">
            {{ title }}
            <IconChevronDown :rotate="is_open" class="w-4 h-4 text-gray-800 transition"/>
        </div>
        <div
            class="h-full ps-3 pe-3 overflow-x-hidden overflow-y-scroll transition-all custom-scroll"
            :class="{'max-h-[0px]': !is_open, 'max-h-[250px]': is_open}">
            <slot/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.custom-scroll::-webkit-scrollbar {
    width: 16px;
}

.custom-scroll::-webkit-scrollbar-track {
    border-radius: 8px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    height: 56px;
    border-radius: 8px;
    border: 5px solid transparent;
    background-clip: content-box;
    background-color: #4241B8;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}
</style>
